import React from "react";

import { ImageSlider } from "./ImageSlider";



const banquetImages = [

  {

    src: "/sala1.jpg",

    alt: "Banket sala RESTORAN KRČMA – pogled 1",

    caption: "Banket sala – pogled na prostor."

  },

  {

    src: "/sala2.jpg",

    alt: "Banket sala RESTORAN KRČMA – pogled 2",

    caption: "Banket sala – enterijer i postavka."

  },

  {

    src: "/sala3.jpg",

    alt: "Banket sala RESTORAN KRČMA – pogled 3",

    caption: "Banket sala – atmosfera za proslave."

  },

  {

    src: "/sala4.jpg",

    alt: "Banket sala RESTORAN KRČMA – pogled 4",

    caption: "Banket sala – prostor za događaje."

  }

];



export function BanquetSection() {

  return (

    <section className="section banquet-section">

      <div className="section-inner">

        <header className="section-header">

          <p className="section-eyebrow">Banket sala</p>

          <h1 className="section-title">Savršeno mesto za vaše najlepše trenutke</h1>

          <p className="section-subtitle">

            Naša banket sala pruža moderan i elegantan prostor idealan za sve vrste

            proslava i događaja. Bilo da organizujete venčanje, rođendan, krštenje ili

            poslovni skup, ambijent je osmišljen da odgovara i svečanim i formalnim

            prilikama.

          </p>

        </header>

      </div>



      <div className="slider-fullbleed">

        <ImageSlider images={banquetImages} auto interval={7000} />

      </div>



      <div className="section-inner banquet-body">

        <div className="banquet-content">

          <h2 className="banquet-content-heading">Banket sala</h2>

          <p>
            Naša banket sala predstavlja idealan izbor za organizaciju svih vrsta
            proslava i svečanosti. Prostor je pažljivo uređen kako bi pružio prijatan,
            elegantan i funkcionalan ambijent, pogodan za venčanja, rođendane, krštenja,
            mature, kao i poslovne događaje.
          </p>

          <p>
            Sala je predviđena za proslave do 190 osoba, uz mogućnost fleksibilnog
            rasporeda koji se prilagođava vašim potrebama i tipu događaja. Savremeno
            ozvučenje i rasveta dodatno doprinose atmosferi i omogućavaju da svaki
            trenutak bude ispunjen.
          </p>

          <p className="banquet-pre-cta">
            Za maksimalnu udobnost gostiju obezbeđen je i prostran parking prostor,
            popločan behatonom, sa kapacitetom do 180 vozila, što garantuje lak pristup
            i bezbrižan dolazak svih zvanica.
          </p>

          <div className="banquet-cta">

            <p>
              Prepustite organizaciju nama i obezbedite sebi proslavu za pamćenje.
              Pozovite nas za informacije o terminima, organizaciji i ponudi menija.
            </p>

            <a href="tel:034354571" className="btn btn-primary">

              POZOVITE NAS

            </a>

          </div>

        </div>

      </div>

    </section>

  );

}


